import { useGetAllPaymentSettingModifiersQuery } from '@bo-services/members/memberGroupsApi';
import { useMemo } from 'react';

/** Fetches and contains a set of all member group payment setting modifiers.
 * Needed because payment setting modifier priorities need to be unique.
 * @param skip - Skips automatic fetching on mount */
export function usePaymentSettingModifiers(skip?: boolean) {
  const {
    data: modifiers,
    refetch: refetchModifiers,
    isLoading: isLoadingModifiers,
    isFetching: isFetchingModifiers
  } = useGetAllPaymentSettingModifiersQuery(undefined, { skip });

  const priorities = useMemo<Set<number>>(() => {
    if (!modifiers) return new Set();
    return new Set(modifiers.map((modifier) => modifier.priority));
  }, [modifiers]);

  return {
    priorities,
    modifiers,
    refetchModifiers,
    isLoadingModifiers,
    isFetchingModifiers
  };
}
